import React from 'react';
import { Grid, Typography } from "@material-ui/core";
import '../../App.css'
import { ThemeProvider } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../../theme';
import globalUseStyles from '../../styleHooks';


function OurSolutionsFeatured() {
  const globalClasses = globalUseStyles()
  return (
<ThemeProvider theme={theme}>
    <Container className={globalClasses.featuredContainer} maxWidth={false} component="section">
        <Grid className={globalClasses.containerSmall} container >
            <Grid item xs={12} md={12}  >
                <Typography  variant="subtitle1">Our Services and Solutions</Typography>
                <Typography  variant="h1">Custom Solutions collaboratively built to serve your audience.  </Typography>
                <Typography  variant="body1">We take the time to understand our clients, their workstyles, and desires to develop and provide the best solution. Combining our solution areas will provide you with a best practice approach within the industry and knowledgeable and responsive team members to advocate for your needs. </Typography>
            </Grid>
        </Grid>
    </Container>
</ThemeProvider>
  );
};

export default OurSolutionsFeatured;